import { hot } from 'react-hot-loader';
import { Link } from 'react-router-dom';
import { useParams } from "react-router-dom";
import { useSelector } from 'react-redux';
import Number from 'react-number-format';
import { utils } from 'ethers';
import { useEagerConnect, useActiveWeb3React } from '../hooks/index';
//import useAuth from '../hooks/useAuth';
import LinkExternal from '../components/Link/LinkExternal';
import getNftContract from '../hooks/getNftContract';
import getNftAddress from '../hooks/getNftAddress';
import getRnctContract from '../hooks/getRnctContract';
import getRnctAddress from '../hooks/getRnctAddress';
import Card from '../components/Card';
import logo from '../../public/logo.jpg';
import Details from '../components/Details';
import * as S from '../store/selectors';
import { ipfsPrfix } from '../configs';

import { useMediaPredicate } from 'react-media-hook';
import { mobileBreakpoint } from '../helpers/Media';

import './ScreenTerms.scss';



function ScreenDetails(props) {
  let { tokenId } = useParams();
  const traitsCount = useSelector(S.nft.getTraitsCount);
  const traits = useSelector(S.nft.getTraits);
  const tokens = useSelector(S.nft.getTokens);

  const token = tokens.length > 0 ? tokens[tokenId - 1] : null;
  return (
    <section className="section-terms">
      <div className="container" data-aos="fade-in" data-delay="200">
        <div className="pre-title">
          <Link className="pre-title-back" to="/wallet">
            &larr; Go to Wallet
          </Link>
        </div>

        <div className="row text-center">
          <div className="textpage">
            <div className="col-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
              <Card
                //poster={nft1Img} posterhd={`${nft1X2Img} 2x`}
                poster={`${ipfsPrfix}${token ? token.previewIpfs : 'QmWG8P7koQoujLc3zn7zZR6HKarinpDtoKx5oaqjtu7fYi'}`}
                name={`${(token && token.isMinted) ? token.traits.Surname : 'Roborovski'} #${tokenId}`}
              /*summ="2.28"
              icon1="1"
              icon2="4"*/
              />

              {/*<h2 className="title text-center mt-5" style={{ color: 'rgb(251, 189, 116)' }}>
                ROBOROVSKI #{tokenId}
              </h2>*/}
            </div>
            <br />
            <Details tokenId={tokenId} token={token} />
            <br />
          </div>
        </div>
      </div>
    </section>
  );
};

export default hot(module)(ScreenDetails);
